import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { UploadCloud, Film } from "lucide-react";
import { toast } from "sonner";

export default function MediaUpload({
  value,
  onChange,
  kind = "image", // "image" or "video"
  testid = "media-upload",
}) {
  const [busy, setBusy] = useState(false);
  const accept =
    kind === "video"
      ? "video/mp4,video/webm,video/quicktime"
      : "image/jpeg,image/png,image/webp";

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success(kind === "video" ? "Video caricato" : "Immagine caricata");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3">
        <label className="av-pill av-pill-ghost text-xs cursor-pointer" data-testid={`${testid}-label`}>
          {kind === "video" ? <Film size={14} /> : <UploadCloud size={14} />}
          {busy
            ? "Carico…"
            : kind === "video"
            ? "Carica video (mp4/webm)"
            : "Carica immagine"}
          <input type="file" accept={accept} className="hidden" onChange={handle} data-testid={testid} />
        </label>
        {value && kind === "image" && (
          <img src={value} alt="" className="w-10 h-10 rounded object-cover border av-hairline" />
        )}
        {value && kind === "video" && (
          <span className="text-[11px] text-[#A39E93] truncate max-w-[180px]">
            {value.split("/").pop()}
          </span>
        )}
      </div>
      <input
        className="av-input mt-2"
        placeholder={kind === "video" ? "…oppure incolla un URL (YouTube, Vimeo, mp4)" : "…oppure incolla un URL"}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
